import { render, staticRenderFns } from "./DistrictBill.vue?vue&type=template&id=18093b4a&scoped=true&"
import script from "./DistrictBill.vue?vue&type=script&lang=js&"
export * from "./DistrictBill.vue?vue&type=script&lang=js&"
import style0 from "./DistrictBill.vue?vue&type=style&index=0&id=18093b4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18093b4a",
  null
  
)

export default component.exports